(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Crossfades the hero slides on a timer and loops back to the first one. Pauses while the
   * tab is hidden or the slideshow is scrolled out of view so it never animates off-screen.
   */
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero__slideshow-slide'));
      if (this.slides.length === 0) return;

      this.index = Math.max(
        this.slides.findIndex((slide) => slide.hasAttribute('data-active')),
        0
      );
      this.slides[this.index].setAttribute('data-active', '');
      if (this.slides.length < 2) return;

      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.advance = this.advance.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

      this.observer = new IntersectionObserver((entries) => {
        entries[0].isIntersecting ? this.start() : this.stop();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange() {
      document.hidden ? this.stop() : this.start();
    }

    start() {
      this.stop();
      this.timer = setInterval(this.advance, this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    advance() {
      this.slides[this.index].removeAttribute('data-active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].setAttribute('data-active', '');
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
